@if (configuration.display) {
<div
    ras-render-element
    [content]="configuration.content"
    (jump)="onPageJump($event)"
></div>
}
